<template>
  <div id="app" class="wrapper" style="padding-right: 2px; padding-left: 2px">
    <div class="content-wrapper">
      <div class="app">
        <div style="display: flex; place-content: center">
          <img
            class="imagem_produto"
            v-show="!errorImage"
            v-bind:src="urlImageProduto(contrato, product.cd)"
            v-bind:alt="product.cd"
            @load="errorImage = false"
            @error="errorImage = true"
          />
        </div>
        <div
          :style="{
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'space-between',
            flexDirection: 'column',
          }"
        >
          <label class="cor-preta nome_produto">
            <b style="font-size: 18px">{{ product.nm }}</b>
          </label>
          <label class="cor-cinza" style="padding: 5px">
            <b :style="{ color: corDescricao }"> {{ product.ingredientes }}</b>
          </label>
          <label class="cor-cinza">
            <b>R$ {{ total }}</b>
          </label>
        </div>
        <br />
        <div>
          <div>
            <div>
              <label class="cor-preta" :style="{ color: corTexto }"
                ><b>{{ nome_ordens[index].nm }}</b></label
              ><br />
            </div>
          </div>

          <div>
            <label class="cor-preta" :style="{ color: corTexto }"
              ><b class="letra-pequena"
                >Mínima :
                {{ formatarSelecao(nome_ordens[index].selecao_min) }}</b
              ></label
            >
            <label class="cor-preta" :style="{ color: corTexto }"
              ><b class="letra-pequena"
                >Máxima :
                {{ formatarSelecao(nome_ordens[index].selecao_max) }}</b
              ></label
            >
          </div>
          <div id="listandoordem">
            <table class="table">
              <thead>
                <tr>
                  <th scope="col">
                    <label class="cor-preta" :style="{ color: corTexto }"
                      ><b></b
                    ></label>
                  </th>
                  <th scope="col">
                    <label class="cor-preta" :style="{ color: corTexto }"
                      ><b>Opções</b></label
                    >
                  </th>
                  <th scope="col">
                    <label class="cor-preta" :style="{ color: corTexto }"
                      ><b>Preço</b></label
                    >
                  </th>
                  <th scope="col">
                    <label class="cor-preta" :style="{ color: corTexto }"
                      ><b></b
                    ></label>
                  </th>
                  <th scope="col">
                    <label class="cor-preta" :style="{ color: corTexto }"
                      ><b></b
                    ></label>
                  </th>
                  <th scope="col">
                    <label class="cor-preta" :style="{ color: corTexto }"
                      ><b></b
                    ></label>
                  </th>
                </tr>
              </thead>

              <tbody v-for="(adicional, idx) of adicionais" :key="adicional.cd">
                <tr>
                  <td align="center">
                    <input
                      @change="ativaQtd(idx, adicional)"
                      type="checkbox"
                      :id="adicional"
                      :value="adicional"
                      v-model="checkedNames"
                    />
                  </td>
                  <td>
                    <p
                      style="max-width: 90%; word-wrap: break-word"
                      :style="{ color: corTexto }"
                    >
                      {{ adicional.nm }}
                    </p>
                  </td>
                  <td :style="{ color: corTexto }">
                    R$ {{ retornaValorAdicional(adicional.vl) }}
                  </td>
                  <td v-if="nome_ordens[index].selecao_max != '1'">
                    <button
                      @click="menosqtd(adicional, idx)"
                      class="btn btn-dark"
                    >
                      -
                    </button>
                  </td>
                  <td v-if="nome_ordens[index].selecao_max != '1'">
                    <label :style="{ color: corTexto }" class="cor-preta"
                      ><b>{{ adicional.qtd }}</b></label
                    >
                  </td>
                  <td v-if="nome_ordens[index].selecao_max != '1'">
                    <button
                      @click="somarqtd(adicional, idx)"
                      class="btn btn-dark"
                    >
                      +
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div
          style="justify-content: flex-start; padding: 0px"
          class="modal-footer"
        >
          <div v-if="index === nome_ordens.length - 1">
            <b>Alguma observação ?</b>
            <textarea
              class="form-control"
              v-model="obs"
              id="obs"
              name="obs"
              rows="2"
              placeholder="Ex: Digite as observações aqui..."
            ></textarea>
            <br />
            <table border="0">
              <thead>
                <tr>
                  <td width="350" valign="top">
                    <li align="left" v-if="index > 0">
                      <button
                        style="background-color: #dc3545"
                        @click="menosindex(checkedNames, adicionaispergunta)"
                        type="button"
                        class="btn btn-dark"
                      >
                        Voltar
                      </button>
                    </li>
                    <li v-else-if="verificarPizza()">
                      <button
                        style="background-color: #dc3545"
                        @click="pushVoltar()"
                        type="button"
                        class="btn btn-dark"
                      >
                        Voltar
                      </button>
                    </li>
                  </td>
                  <td width="100">
                    <li align="center"></li>
                  </td>
                  <td width="480" valign="top">
                    <li align="right">
                      <button
                        style="background-color: #006400"
                        @click="
                          somaadicionais(
                            checkedNames,
                            adicionaispergunta,
                            nome_ordens,
                            product,
                            obs
                          )
                        "
                        type="button"
                        class="btn btn-dark"
                      >
                        Continuar
                      </button>
                    </li>
                  </td>
                </tr>
              </thead>
            </table>
          </div>
          <div v-else>
            <table border="0">
              <thead>
                <tr>
                  <td width="350" valign="top">
                    <li align="left" v-if="index > 0">
                      <button
                        style="background-color: #dc3545"
                        @click="
                          menosindex(
                            checkedNames,
                            adicionaispergunta,
                            nome_ordens
                          )
                        "
                        type="button"
                        class="btn btn-dark"
                      >
                        Voltar
                      </button>
                    </li>
                    <li v-else-if="verificarPizza()">
                      <button
                        style="background-color: #dc3545"
                        @click="pushVoltar()"
                        type="button"
                        class="btn btn-dark"
                      >
                        Voltar
                      </button>
                    </li>
                  </td>
                  <td width="100">
                    <li align="center"></li>
                  </td>
                  <td width="480" valign="top">
                    <li align="right">
                      <button
                        style="background-color: #006400"
                        @click="
                          somaindex(
                            checkedNames,
                            adicionaispergunta,
                            nome_ordens
                          )
                        "
                        type="button"
                        class="btn btn-dark"
                      >
                        Continuar
                      </button>
                    </li>
                  </td>
                </tr>
              </thead>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Adicional from "../services/adicional";
import Ordem from "../services/nome_ordem";
import Inis from "../services/inis";
import Swal from "sweetalert2";
import SecureLS from "secure-ls";
var ls = new SecureLS({ encodingType: "aes" });

export default {
  name: "Perguntas",
  data() {
    return {
      corFundo: "",
      corTexto: "",
      corBotao: "",
      corDescricao: "",
      obs: "",
      product: [],
      checkedNames: [],
      adicionaispergunta: [],
      search: "",
      product: {
        cd: "",
        nm: "",
        classe: "",
        ingredientes: "",
        vl: "",
        vl_promo: "",
      },
      nome_ordens: [],
      nome_ordem: {
        cd: "",
        nm: "",
        ordem: "",
        cd_prod: "",
        selecao_min: "",
        selecao_max: "",
      },
      adicionais: [],
      adicional: {
        cd: "",
        cd_prod: "",
        qtd: "",
        vl: "",
        tipo: "",
        nm: "",
        cd_sabor: "",
        ordem: "",
        obs: "",
        cd_prod_pai: "",
        cd_erp: "",
      },
      inis: {
        cd: "",
        vl: "",
        dt_ins: "",
        desc_config: "",
      },
      cdproduto: "",
      nmproduto: "",
      vlproduto: "",
      ingredientesproduto: "",
      classeproduto: "",
      index: 0,
      obj: [],
      qrCodeTempoExpiracao: 0,
      tipo: "",
      listaAdicionaisMarcados: [],
      contrato: "",
      errorImage: true,
    };
  },
  computed: {
    total() {
      var valor = 0;
      if (this.listaAdicionaisMarcados.length != 0) {
        this.listaAdicionaisMarcados.forEach((adicional) => {
          valor = valor + parseFloat(adicional.vl) * parseInt(adicional.qtd);
        });
      }
      var valorPizza = ls.get("sabores" + this.contrato);
      if (this.product.classe == "PIZZAS") {
        valor = valor + parseFloat(valorPizza[0].vl);
      } else {
        valor = valor + parseFloat(this.product.vl);
      }
      valor = valor.toFixed(2);
      return valor;
    },
    ...mapGetters({
      length: "getNumberOfProducts",
    }),
  },
  methods: {
    verificarPizza() {
      if (this.product.classe == "PIZZAS") {
        return true;
      } else {
        return false;
      }
    },
    pushVoltar() {
      this.$router.push("/pizzas");
    },
    listarproduto() {
      this.product = ls.get("product" + process.env.VUE_APP_CONTRATO);

      //alert('Produto Selecionado Adicional: '+this.product);

      Ordem.verificaordem(this.product.cd).then((resposta) => {
        this.nome_ordens = resposta.data.filter((nm_ordem) => {
          return nm_ordem.ativo == "1";
        });

        Adicional.verificaadicional(
          this.product.cd,
          this.nome_ordens[0].ordem
        ).then((resposta) => {
          this.adicionais = resposta.data.filter((adicional) => {
            adicional.qtd = 0;
            adicional.vl = parseFloat(adicional.vl).toFixed(2);
            return adicional.ativo == "1";
          });
          /* alert(JSON.stringify(this.product.cd));
        alert(JSON.stringify(this.nome_ordens)); */
        });
      });
    },
    listarinis() {
      Inis.listarinis().then((resposta) => {
        this.inis = resposta.data;
      });
      var cd = "Cor_primaria";
      Inis.listarInisCd(cd).then((response) => {
        this.corFundo = response.data[0].vl;
      });
      var cd = "Cor_secundaria";
      Inis.listarInisCd(cd).then((response) => {
        this.corBotao = response.data[0].vl;
      });
      var cd = "Cor_tercearia";
      Inis.listarInisCd(cd).then((response) => {
        this.corTexto = response.data[0].vl;
      });
      var cd = "COR_DESCRICAO";
      Inis.listarInisCd(cd).then((resposta) => {
        this.corDescricao = resposta.data[0].vl;
      });
      var cd = "TEMPO_QRCODE";
      Inis.listarInisCd(cd).then((response) => {
        this.qrCodeTempoExpiracao = response.data[0].vl;
      });
    },
    formatarSelecao(selecao) {
      if (selecao == "0") {
        return "Nenhum";
      } else if (selecao == "-1") {
        return "Ilimitado";
      } else {
        return selecao;
      }
    },

    //menos index
    menosindex(checkedNames, adicionaispergunta) {
      this.index = 0;
      //alert(JSON.stringify(index));
      this.checkedNames = [];
      this.adicionaispergunta = [];
      /* 		checkedNames.pop();
  	
    adicionaispergunta.pop(); */

      Adicional.verificaadicional(
        this.product.cd,
        this.nome_ordens[this.index].ordem
      ).then((resposta) => {
        this.adicionais = resposta.data.filter((adicional) => {
          adicional.qtd = 0;
          adicional.vl = parseFloat(adicional.vl);
          return adicional.ativo == "1";
        });
        //alert(JSON.stringify(resposta.data));
      });

      /*checkedNames.forEach((item) => {
      this.adicionaispergunta.push(item);
    })*/

      //alert(JSON.stringify(this.adicionaispergunta));

      while (checkedNames.length) {
        checkedNames.pop();
      }
      if (this.verificarPizza() == true) {
        this.$router.push("/pizzas");
      }
    },

    somaadicionais(
      checkedNames,
      adicionaispergunta,
      nome_ordens,
      product,
      obs
    ) {
      var d1 = this.$store.state.date_token;
      var d2 = moment().format("YYYY-MM-DD hh:mm:ss");
      var diff = moment(d2, "YYYY-MM-DD HH:mm:ss").diff(
        moment(d1, "YYYY-MM-DD HH:mm:ss")
      );
      diff = diff / 60000;
      if (nome_ordens[this.index].selecao_max != -1) {
        if (
          this.somatorioAdicionais(checkedNames) >
          nome_ordens[this.index].selecao_max
        ) {
          Swal.fire({
            title:
              "Você pode selecionar no máximo " +
              nome_ordens[this.index].selecao_max +
              " item(s).",
            confirmButtonColor: "#000000",
          });

          return false;
        } else if (
          this.somatorioAdicionais(checkedNames) <
          nome_ordens[this.index].selecao_min
        ) {
          Swal.fire({
            title: `Selecione pelo menos ${
              nome_ordens[this.index].selecao_min
            } opção(ões).`,
            confirmButtonColor: "#000000",
          });
          return false;
        }
      }
      if (
        this.somatorioAdicionais(checkedNames) <
        nome_ordens[this.index].selecao_min
      ) {
        Swal.fire({
          title: `Selecione pelo menos ${
            nome_ordens[this.index].selecao_min
          } opção(ões).`,
          confirmButtonColor: "#000000",
        });
        return false;
      }

      checkedNames.forEach((item) => {
        if (item.tipo === "M") {
          item.nm = "s/" + item.nm;
        } else if (item.tipo === "D") {
          item.nm = "c/" + item.nm;
        }
        this.adicionaispergunta.push(item);
      });

      if (this.$store.state.funcionamento === "0") {
        Swal.fire({
          title: "Estabelecimento fechado",
          confirmButtonColor: "#000000",
        });
      } else if (diff > this.qrCodeTempoExpiracao) {
        console.log("chegou aqui");
        Swal.fire({
          title: "Tempo de conexão expirou! Leia o QRcode novamente!",
          confirmButtonColor: "#000000",
        });
      } else if (this.$store.state.funcionamento === "1") {
        if (adicionaispergunta.length == 0) {
          let item = new Object();
          item.nm = "";
          item.vl = 0;
          item.qtd = 1;
          adicionaispergunta.push(item);
        }
        if (this.product.classe == "PIZZAS") {
          this.obj = ls.get("sabores" + this.contrato);
          adicionaispergunta = this.obj.concat(adicionaispergunta);
          if (this.tipo === "3" || this.tipo === "2") {
            product.vl = 0;
          }
          if (this.tipo === "1") {
            adicionaispergunta[0].vl = 0;
          }
        }

        adicionaispergunta.forEach((adicional) => {
          if (adicional.qtd > 1) {
            adicional.nm = `${adicional.qtd}x ${adicional.nm}`;
          }
        });

        this.$store.dispatch("addToCart", {
          product,
          adicionaispergunta,
          obs,
        });

        this.$router.push("/cart");
        while (checkedNames.length) {
          checkedNames.pop();
        }
      }
    },

    //somar index
    somaindex(checkedNames, adicionaispergunta, nome_ordens) {
      if (nome_ordens[this.index].selecao_max != -1) {
        if (checkedNames.length > nome_ordens[this.index].selecao_max) {
          Swal.fire({
            title:
              "Você pode selecionar no máximo " +
              nome_ordens[this.index].selecao_max +
              " item(s).",
            confirmButtonColor: "#000000",
          });
          /* alert(
            "Você pode selecionar no máximo " +
              nome_ordens[this.index].selecao +
              " item(s)."
          ); */
          return;
        }
      }
      if (
        this.somatorioAdicionais(checkedNames) >
          nome_ordens[this.index].selecao_max &&
        nome_ordens[this.index].selecao_max != "-1"
      ) {
        Swal.fire({
          title: `Selecione pelo menos ${
            nome_ordens[this.index].selecao_max
          } opção(ões).`,
          confirmButtonColor: "#000000",
        });
        return false;
      }
      if (
        this.somatorioAdicionais(checkedNames) <
        nome_ordens[this.index].selecao_min
      ) {
        Swal.fire({
          title: `Selecione pelo menos ${
            nome_ordens[this.index].selecao_min
          } opção(ões).`,
          confirmButtonColor: "#000000",
        });
        return false;
      }
      this.index += 1;
      //alert(this.index);

      checkedNames.forEach((item) => {
        if (item.tipo === "M") {
          item.nm = "s/" + item.nm;
        } else if (item.tipo === "D") {
          item.nm = "c/" + item.nm;
        }
        this.adicionaispergunta.push(item);
      });

      //alert(JSON.stringify(this.product.cd));
      //alert(JSON.stringify(this.nome_ordens[this.index].ordem));

      Adicional.verificaadicional(
        this.product.cd,
        this.nome_ordens[this.index].ordem
      ).then((resposta) => {
        this.adicionais = resposta.data.filter((adicional) => {
          adicional.qtd = 0;
          adicional.vl = parseFloat(adicional.vl);
          return adicional.ativo == "1";
        });
        //alert(JSON.stringify(resposta.data));
      });

      while (checkedNames.length) {
        checkedNames.pop();
      }
    },
    somatorioAdicionais(checkedNames) {
      if (checkedNames.length > 0) {
        const somatorio = checkedNames.reduce(
          (acumulador, adicional /* , index, array */) => {
            return acumulador + adicional.qtd;
          },
          0
        );
        return somatorio;
      } else {
        return 0;
      }
    },
    //verificaselecao
    verificaselecao(checkedNames, nome_ordens) {
      if (
        checkedNames.length === 0 ||
        checkedNames.length === "" ||
        checkedNames.length == null
      ) {
        Swal.fire({
          title: "Selecione pelo menos uma opção.",
          confirmButtonColor: "#000000",
        });
        //alert("Selecione pelo menos uma opção.");
      } else {
        if (checkedNames.length > nome_ordens) {
          Swal.fire({
            title:
              "Você pode selecionar no máximo " + nome_ordens + " item(s).",
            confirmButtonColor: "#000000",
          });
          //alert("Você pode selecionar no máximo " + nome_ordens + " item(s).");
        } else {
          return false;
        }
      }
    },
    menosqtd(adicional, index) {
      if (this.adicionais[index].qtd >= 1) {
        this.adicionais[index].qtd -= 1;
        if (this.adicionais[index].qtd == 0) {
          this.checkedNames = this.checkedNames.filter((ad) => {
            if (ad.cd != adicional.cd) {
              return ad;
            }
          });
          this.listaAdicionaisMarcados = this.listaAdicionaisMarcados.filter(
            (ad) => {
              if (adicional.cd != ad.cd) {
                return ad;
              }
            }
          );
        }
      } else {
        Swal.fire({
          title: "Obrigatório ter pelo menos um item desse produto.",
          confirmButtonColor: "#000000",
        });
      }
    },

    somarqtd(adicional, index) {
      if (
        this.somatorioAdicionais(this.checkedNames) <
          this.nome_ordens[this.index].selecao_max ||
        this.nome_ordens[this.index].selecao_max == "-1"
      ) {
        if (this.adicionais[index].qtd == 0) {
          this.checkedNames.push(adicional);
          this.listaAdicionaisMarcados.push(adicional);
        }
        this.adicionais[index].qtd += 1;
      } else {
        Swal.fire({
          title: `Limite de adicionais é ${
            this.nome_ordens[this.index].selecao_max
          } .`,
          confirmButtonColor: "#000000",
        });
      }

      //alert(JSON.stringify(index));
    },
    ativaQtd(index, adicional) {
      if (this.adicionais[index].qtd == 0) {
        this.adicionais[index].qtd = 1;
        this.listaAdicionaisMarcados.push(this.adicionais[index]);
      } else {
        this.adicionais[index].qtd = 0;
        this.checkedNames = this.checkedNames.filter((ad) => {
          if (ad.cd != adicional.cd) {
            return ad;
          }
        });
        this.listaAdicionaisMarcados = this.listaAdicionaisMarcados.filter(
          (ad) => {
            if (adicional.cd != ad.cd) {
              return ad;
            }
          }
        );
      }
    },
    retornaValorAdicional(adicional) {
      adicional = parseFloat(adicional).toFixed(2).replace(".", ",");
      return adicional;
    },
    listandoInisTipoPizza() {
      var cd = "PIZZA";
      Inis.listarInisCd(cd).then((resposta) => {
        this.tipo = resposta.data[0].vl;
      });
    },

    urlImageProduto(contrato, prod) {
      return `https://apppanterafood.com.br/DeliCenter/${contrato}/produtos/${prod}.jpg?${performance.now()}`;
    },
    erroImagemProduto(event, contrato) {
      event.target.src =
        "https://apppanterafood.com.br/DeliCenter/" +
        contrato +
        "/produtos/sem_imagem.jpg";
    },

    ...mapActions(["addToCart"]),
  },
  mounted() {
    this.contrato = process.env.VUE_APP_CONTRATO;
    this.listarproduto(), this.listarinis(), this.listandoInisTipoPizza();
  },
};
</script>

<style>
.imagem_produto {
  max-width: 300px;
  max-height: 250px;
  width: 300px;
  height: 250px;

  margin: 1em 0 0;
  border-radius: 0.5em;
  object-fit: cover;
}

.nome_produto {
  font-size: 20px;

  margin: 0.5em 0 0;
}
</style>
